/**
 * @desc 招聘信息
 * @author zhuxusheng@zbj.com
 * @since 2019-11-05
 */
'use strict';
module.exports = {
  'jobList': [ // 模拟职位招聘信息
    {
      positionName: 'JAVA开发工程师',
      workPlace: '重庆',
      positionType: '技术类',
      releaseDate: '2019/08/12',
      department: '产品技术中心',
      isUrgent: true,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.参与系统需求、系统架构的设计和方案讨论，可行性分析，工作量估算；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.深入了解产品和业务需求，协调研发资源，保障项目进度和质量；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.负责帐务核心的开发，核心代码编写。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.5年以上主力开发和架构设计经验；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.熟悉金融业务，具有信贷核心系统建设经验优先；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.熟悉流行的前后端开发技术，如：React，Vue，Angular，SpringBoot，SpringMVC等；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4.具备较好的技术视野和技术选型能力；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5.项目管理经验丰富，独立负责过中大型研发项目，参与过大型复杂分布式系统设计开发，对设计高可用、高性能、可扩展、可伸缩系统有深刻的理解；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6.良好的业务意识，能够业务角度对整体技术做规划。</p>`
    },
    {
      positionName: '融资总监',
      workPlace: '重庆',
      positionType: '市场类',
      releaseDate: '2019/08/11',
      department: '产品技术中心',
      isUrgent: true,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、根据公司战略和经营目标制定融资规划和融资模式，完成融资任务；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、了解分析公司的资金状况与需求，实施相应的融资解决方案并拓展融资渠道，测算融资成本与收益，制定融资计划；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、与银行、非银金融机构建立良好合作关系，并及时掌握融资政策变化，确保融资计划正常进行；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、负责融资渠道的发掘、优化和拓展，进行融资风险分析；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、领导交办的其他工作。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、经济、财务、金融等相关专业，本科以上学历；熟悉国家相关的政策、法规；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、5年以上相关工作经验，具有丰富的商业谈判经验；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、具有有良好的融资分析能力和判断能力；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、金融知识扎实，熟练掌握融资流程和专项业务知识；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、具有丰富的融资渠道和业内广泛的人际关系；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6、具有良好的沟通能力，善于处理复杂的人际关系，良好的团队精神，能够承受高强度的工作压力。 </p>`
    },
    {
      positionName: '安全调查经理',
      workPlace: '重庆',
      positionType: '风控类',
      releaseDate: '2019/08/10',
      department: '产品技术中心',
      isUrgent: true,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、对风控部可疑欺诈合同，对经营点常规、异常情况进行外出调查。对公司内部违规违纪行为进行调查。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、根据公司要求对指定的合作商家，销售人员，客户进行风控排查和反欺诈调查。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、负责与区域销售同事进行反欺诈，控制风控知识的培训与指导。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、完成上级指派的其他调查任务。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、有银行，金融，担保，小额贷款，保险，公安司法机关相关调查经验。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、分析能力，逻辑性强。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、有较强的语言表达能力，灵活的沟通技巧。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、服从意识强，为人正直。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、能适应经常出差，能承受高强度工作压力。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6、退伍军人，军警校毕业生，派出所有工作经验者优先录用。</p>`
    },
    {
      positionName: '大数据开发工程师',
      workPlace: '重庆',
      positionType: '技术类',
      releaseDate: '2019/08/09',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、负责大数据平台的性能监控和持续优化，针对需求提供大数据分析技术解决方案；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、参与数据仓库的设计优化，根据业务设计主题，使用ETL工具将数据抽取到数据仓库,并解决过程中的问题及优化；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、监控每日数据处理效率，分析并优化；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、其他临时交办工作。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、本科及以上学历，相关工作经验3年及以上；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、熟练掌握linux系统常用操作，精通shell；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、精通(oracle,mysql,sqlserver等)数据据库的一种；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、熟练掌握java/python/scala等开发语言的一种；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、熟悉ETL开发流程，并掌握kattle,datastage或其他开源ETL工具的一种；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6、熟练HADOOP,了解HDFS原理及其存储结构，熟练掌握SPARK、HIVE、RANGER、SQOOP,AZKABAN，KAFKA,SPARKSTRAMING等开源数据组件中的三种。 </p>`
    },
    {
      positionName: '审核专员',
      workPlace: '重庆',
      positionType: '风控类',
      releaseDate: '2019/08/08',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、基于既定的信贷风险管理政策及流程规范，负责贷款的审查审批工作；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、核实借款人材料的真实性与完整性，发现并提示风险点，出具审批意见；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、工作中发现风险问题，及时向上级汇报，追踪并控制风险，以及提出审批流程优化建议；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、按照标准流程作业，及时准确完成审批任务，确保审批效率和品质；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、市场端及客户端相关风险数据的收集、反馈与分析。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、全日制大学专科（含）及以上学历，金融、财务、法律、会计等相关专业优先；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、1年以上银行或金融公司相关审核工作经验，熟悉相关法律法规及政策；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、为人正直，责任心及抗压能力强，较好风险合规及团队合作意识；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、逻辑思维与沟通学习能力佳，具备一定风险洞察力和判断力。</p>`
    },
    {
      positionName: '架构师',
      workPlace: '重庆',
      positionType: '技术类',
      releaseDate: '2019/08/07',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、充分理解公司当前业务和未来发展战略，负责金融业务（信贷方向）相关的产品技术架构设计和研发管理工作；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、在保证业务稳定的前提下，推动系统重构和平滑迭代；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、负责重大项目的技术方案评审，技术攻关；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、制定金融平台的技术规范、安全设计指南；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、指导开发工程师的工作，提升他们的技能 。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1、全日制本科，主修计算机、软件工程相关专业；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2、从事金融行业3年及以上，技术从业经验10年以上；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3、良好的团队沟通、协作能力；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4、在金融系统建设领域及业务方面有深厚造诣，对金融科技的前沿技术和发展趋势有独到见解；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5、深刻理解Java语言，熟悉Dubbo，zk，springcloud等分布式框架； </p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6、有独立设计大规模分布式系统的能力，掌握微服务设计的原理、原则，有丰富的微服务系统设计、开发经历。</p>`
    },
    {
      positionName: '产品经理（中后台）',
      workPlace: '重庆',
      positionType: '产品类',
      releaseDate: '2019/08/07',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.负责中后台产品规划、设计并推动上线，对后台产品完整性、安全性负责；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.负责中后台系统整体架构设计，包括审核系统、核心系统等；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.主导项目的需求分析、产品规划&设计、项目管理；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4.负责设计项目所需的需求文档和产品原型；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5.负责产品功能和流程的验收和测试，保证项目品质；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6.负责推进项目进度，协调公司内和外部资源，保证项目按时上线；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">7.负责基于数据分析结果，推动项目流程优化及产品的优化升级；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">8.负责为对接部门提供相关培训，及其他所需解决方案。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.统招全日制本科及以上学历，计算机等理工科专业优先；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.2年及以上工作经验，有产品设计及产品开发经验优先，有互联网金融经验优先</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.产品设计、文档撰写基础扎实，熟练使用VISIO、AXURE、XMIND等工具；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4.具有良好的产品架构及业务架构设计能力，模块化思维，具有长远规划的能力；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5.熟练使用具备较强的沟通及协调能力， 逻辑能力强；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6.为人耐心细致，工作认真，学习能力强，具备非常强的责任心与抗压性。</p>`
    },
    {
      positionName: '催收专员',
      workPlace: '重庆',
      positionType: '风控类',
      releaseDate: '2019/08/06',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.管理和协调团队工作，带领团队达成业绩目标，对部门绩效负责；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.通过有效的管理模式定期稽核团队成员的工作进度；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.有效控制团队客诉及处理工作； </p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4.为公司培养优秀的催收人才，合理调配催收资源；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5.执行催收制度和策略，分析团队催收问题，提出解决方案及优化内部业务流程。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.专科学历及以上，有法律、经济、金融类专业优先；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.具有金融机构及外包公司1年以上的催收经验，自身催收能力过硬；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.较强的沟通、分析判断能力，组织协调能力，抗压能力；</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">4.具有高度责任感和团队合作精神。 </p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">5.具有保密与服务意识； </p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">6.具有带团队经验及团队业绩提升能力。</p>`
    },
    {
      positionName: '前端开发工程师',
      workPlace: '重庆',
      positionType: '技术类',
      releaseDate: '2019/08/01',
      department: '产品技术中心',
      isUrgent: false,
      content: `<h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">岗位职责</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.负责八戒金融产品的研发（包括PC和H5）。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.熟悉业务需求，参与前端架构规划、核心模块的开发建设和技术布道。</p>
                <h2 style="font-size:16px;line-height:66px;height:66px;color:#222222;">任职要求</h2>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">1.思维缜密、思路清晰，较好的逻辑分析能力。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">2.工作有责任心，对公司产品负责，对自己代码负责。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">3.精通JavaScript、Nodejs，有良好的程序设计和架构能力。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;font-weight:bold;">A.产品方向：</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 精通html/xhtml、css等网页制作技术，熟悉页面架构和布局。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 熟悉web标准，对表现与数据分离，html语义化等有深刻理解。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 良好的沟通和口头、书面表达能力。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;font-weight:bold;">B.架构方向：</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 对web技术钻研有强烈兴趣，对前端技术融会贯通，具备快速学习能力。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 对标准化、用户体验、页面性能有深入了解，创造性的提升产品体验。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 有开源项目开发维护/分享交流经历 有一定业界影响力者优先考虑。</p>
                <p style="font-size:16px;line-height:26px;height:26px;color:#222222;">- 有vue、react、hybrid开发经验者优先。</p>`
    },
  ],
}


// WEBPACK FOOTER //
// ./app/resource/global/js/staticData/job.js